/**
 * Página de pedido de Nave 2
 * Muestra productos de un pedido específico en Nave 2
 */
import React, { useContext, useEffect, useState } from "react";
import { Alert, Box, Card, CardContent, CircularProgress } from "@mui/material";
import { ListOrder } from "../components";
import SalesService from "../../../services/sales.service";
import Order from "../../../models/Order";
import ProductFactory from "../../../models/ProductFactory";
import { StateContext } from "../../../components/context/StateProvider";
import withRouter from "../../../components/withRouter";
import OrderService from "../../../services/order.service";
import NotesService from "../../../services/notes.service";
import { INCIDENCIA_ORIGEN } from "../../../config/constants";
import Utils from "../../../utils/Utils";
import { getErrorMessage } from "../../../utils/ErrorUtils";
import { obtenerPreparadoresNave1 } from "../helpers/preparadorNave1";


const OrderN2 = (props) => {

    const {updateState, state} = useContext(StateContext);

    // Carga del pedido: ListOrder no tiene estado de carga propio y, sin esto, el card
    // se quedaba en blanco hasta que llegaban los productos
    const [cargando, setCargando] = useState(true);
    const [errorCarga, setErrorCarga] = useState(null);

    /**
     * Obtener información incidencias de Nave 2 del albarán (solo aplica si tiene serie)
     */
    const getNoteOrder = async (order, orderNum) => {
        const infoOrder = Utils.getOrder(orderNum);

        if (!infoOrder.serie) return;

        const currentNote = await NotesService.getNoteByNum(infoOrder.serie, infoOrder.order, INCIDENCIA_ORIGEN.NAVE2);

        if (currentNote && Object.keys(currentNote).length > 0) {
            order.Note = currentNote;
        }
    };

    // Carga inicial y limpieza del estado global al salir. El contexto capturado aquí
    // no se queda obsoleto: Content.js monta las páginas con key={state.year}, así que
    // un cambio de ejercicio remonta el componente en vez de re-renderizarlo.
    useEffect(() => {
        const cargar = async () => {

            const orderNum = props.params.order;
            const type = props.search.get('tipo');

            await SalesService.getSalesProductN2(orderNum, state.year, type).then(
                async (data) => {

                const stateContext = state;

                let order = new Order();
                order.route = props.search.get('ruta');

                let complete = 0;
                let lastUpdated = null;

                const salesMap = data.map(async (sale, index) => {

                    let state = 0;
                    let remaining = sale.UNIDADES;
                    let register = 0;
                    let registerDate = undefined;
                    let manual = false;

                    if (!Utils.checkRefProduct(sale.ARTICULO)) {

                        let refArticulo = sale.ARTICULO;

                        if (sale.DUPLICADO) {
                            refArticulo += '-' + sale.LINIA;
                        }

                        // Obtener ventas
                        const saleRegistry = await SalesService.getSalesProduct(sale.LETRA+'-'+sale.NUMERO, refArticulo, stateContext.year, 2, type);

                        // Comprobar ventas quedan quedan por añadir
                        if (saleRegistry.length > 0) {
                            remaining = sale.UNIDADES - saleRegistry[0].unidades;
                            register = saleRegistry[0].unidades;

                            // Cambiar el estado en funcion de los bultos
                            if (remaining === 0) {
                                state = 1;
                                complete += 1;
                            }

                            registerDate = saleRegistry[0].registrado;
                            manual = saleRegistry[0].manual;

                            if (lastUpdated === null || lastUpdated < new Date(saleRegistry[0].registrado)) {
                                lastUpdated = new Date(saleRegistry[0].registrado);
                            }
                        }

                    } else {
                        sale.UNIDADES = 0;
                        remaining = 0;
                        state = 1;
                        complete += 1;
                    }

                    let barrasModels = 'BarrasModels';
                    if (stateContext.year !== Utils.getCurrentYear()) {
                        barrasModels = 'BarrasModel'+stateContext.year+'s';
                    }

                    let product = ProductFactory.productOrder(sale.LETRA+'-'+sale.NUMERO, sale.ARTICULO, sale.INFO_ARTICULO[barrasModels], sale.INFO_ARTICULO.NOMBRE,
                        sale.UNIDADES, sale.INFO_ARTICULO.UBICACION, sale.INFO_ARTICULO.VENSERIE, remaining, state, register, sale.DUPLICADO, sale.LINIA, registerDate, manual, index);
                    product.stock = sale.INFO_ARTICULO?.Stocks2Models;
                    return product;
                });

                const orderState = await OrderService.getStateOrderN2(orderNum, state.year, type);

                if (orderState.length > 0) {
                    order.preparer = (orderState[0].preparado === null ? '0' : orderState[0].preparado);
                    order.state = orderState[0].estado;

                    // Descomentar para no poder actualizar pedido una vez preparado
                    // if (order.state === '2') {
                    //     order.complete = true;
                    // }
                }

                const salesMapFull = await Promise.all(salesMap);

                // Preparador de nave 1, para el ticket impreso
                order.preparadoresN1 = await obtenerPreparadoresNave1([{ numero: orderNum, tipo: type }], state.year);

                // Cargar la incidencia existente del albarán (igual que Sales) para que
                // al crear una desde N2 se actualice en vez de machacar la existente
                await getNoteOrder(order, orderNum);

                order.num = orderNum;
                order.n2 = true;
                order.complete = complete === data.length;
                order.tipo = type;
                updateState({order: order});
                updateState({products: salesMapFull})
                updateState({loading: false});
                updateState({filters: []})
                }
            );
        };

        // DECISION: igual que OrderN2Grupo, el punteo no se pinta hasta tener el pedido:
        // en una pantalla de escaneo, mostrar algo a medias induce a puntear sin datos
        cargar()
            .catch((error) => {
                console.error('Error al cargar el pedido de nave 2:', error);
                setErrorCarga(getErrorMessage(error, 'No se pudo cargar el pedido'));
            })
            .finally(() => setCargando(false));

        return () => {
            updateState({toasts: []})
            updateState({products:[]});
            updateState({order: new Order()});
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
            <Box id="sales" sx={{ width: "100%" }}>
                <Card sx={{ p: { xs: 2, sm: 3 } }}>
                    <CardContent sx={{ "&:last-child": { pb: { xs: 2, sm: 3 } } }}>
                        {cargando ? (
                            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 8 }}>
                                <CircularProgress size={40} sx={{ color: "#cc071e" }} />
                            </Box>
                        ) : errorCarga ? (
                            <Alert severity="error">{errorCarga}</Alert>
                        ) : (
                        <ListOrder
                            nave={'2'}
                            type={props.search.get('tipo').toLowerCase()}
                            registerAction={SalesService.registerSale}
                            handle={'ventas'}
                            read={false}
                            preparer={true}
                            reviewer={false}
                            camera={false}
                            orderStateN2={true}
                        />
                        )}
                    </CardContent>
                </Card>
            </Box>
    );
};

export default withRouter(OrderN2);